import { useQuery } from "@tanstack/react-query";

import { getMyUser } from "@/api";

const useFetchMe = () => {
  return useQuery({ queryKey: ["my-user"], queryFn: getMyUser });
};

export { useFetchMe };
